const desktopFontFamily = 'Poppins'
const mobileFontFamily = 'Roboto'

const FONT = {
  h1: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 80,
    lineHeight: '90px',
    letterSpacing: 1
  },
  h2: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 48,
    lineHeight: '50px',
    letterSpacing: 1
  },
  h3: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 32,
    lineHeight: '34px',
    letterSpacing: 1
  },
  h4: {
    fontFamily: 'Space Grotesk',
    fontWeight: '400',
    fontSize: 28,
    lineHeight: '38px',
    letterSpacing: 0.75
  },
  h5: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 20,
    lineHeight: '34px',
    letterSpacing: 0.75
  },
  h6: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: '28px',
    letterSpacing: 0.75
  },
  button: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: '28px',
    letterSpacing: 0.75
  },
  captionText: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 14,
    lineHeight: '28px',
    letterSpacing: 0.75
  },
  text: {
    fontFamily: 'Space Grotesk',
    fontWeight: '400',
    fontSize: 14,
    lineHeight: '24px',
    letterSpacing: 0.75
  },
  smallContent: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 12,
    lineHeight: '22px',
    letterSpacing: 0.75
  },
  tinyText: {
    fontFamily: 'Space Grotesk',
    fontWeight: '700',
    fontSize: 8,
    lineHeight: '22px',
    letterSpacing: 0.75
  },
  smallCaptionText: {
    fontFamily: 'Space Grotesk',
    fontWeight: '400',
    fontSize: 12,
    lineHeight: '22px',
    letterSpacing: 0.75
  },
};

export default FONT;
